import Config from   './../../config/app';

//When loaded, updates the golobal Config.js in src/config/app.js
var designSettings={
    linkButtonNormalClass:"btn",
    submitButtonClass:"btn btn-fill btn-rose",
    buttonInfoClass:"btn btn-info",
    buttonSuccessClass:"btn btn-success",
    editElementDivClass:"form-group label-floating is-empty",
    sideMenuTextWrappedInParagraph:true,
}

Config.designSettings=designSettings;



// WEBPACK FOOTER //
// ./src/ui/template/Config.js